/**
 * This ID is used to surpress duplicate toasts.
 * Use this to only show the error from the API (if one is present)
 * https://fkhadra.github.io/react-toastify/prevent-duplicate
 */
export const REACT_TOASTIFY_API_ERROR_ID = 'API_ERROR';
